import React from 'react'
import { Form } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { TrainingSessionFormData } from '../../hooks/useTrainingSessionForm'
import { Intensity } from '../../types/exercise.type'
import { TrainingSessionGroup } from '../../types/training-session-group.type'
import RichTextEditor from '../common/RichTextEditor'
import Label from '../form/Label'

interface TrainingSessionBasicFieldsProps {
    formData: TrainingSessionFormData
    groups: TrainingSessionGroup[]
    onInputChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => void
    onDescriptionChange: (value: string) => void
}

const TrainingSessionBasicFields: React.FC<TrainingSessionBasicFieldsProps> = ({
    formData,
    groups,
    onInputChange,
    onDescriptionChange,
}) => {
    const { t } = useTranslation()

    return (
        <>
            <Form.Group className="mb-3">
                <Label>{t('coach.trainingSessions.title')} *</Label>
                <Form.Control type="text" name="title" value={formData.title} onChange={onInputChange} required />
            </Form.Group>

            <Form.Group className="mb-3">
                <Label>{t('coach.trainingSessions.description')}</Label>
                <RichTextEditor 
                    key={`description-${formData.id || 'new'}`}
                    value={formData.description || ''} 
                    onChange={onDescriptionChange} 
                />
            </Form.Group>

            <Form.Group className="mb-3">
                <div className="row">
                    <div className="col-md-6">
                        <Label>{t('coach.trainingSessions.intensity')} *</Label>
                        <Form.Select
                            name="intensity"
                            value={formData.intensity}
                            onChange={onInputChange}
                            required
                            className="form-select"
                        >
                            {Object.values(Intensity).map((intensity) => (
                                <option key={intensity} value={intensity}>
                                    {t(`intensity.${intensity.toLowerCase()}`)}
                                </option>
                            ))}
                        </Form.Select>
                    </div>
                    <div className="col-md-6">
                        <Label>Ordre</Label>
                        <Form.Control
                            type="number"
                            name="order"
                            min="1"
                            value={+formData.order}
                            onChange={onInputChange}
                            className="form-control"
                        />
                    </div>
                </div>
            </Form.Group>

            <Form.Group className="mb-3">
                <Label>{t('coach.trainingSessions.group')}</Label>
                <Form.Select name="groupId" value={formData.groupId ?? ''} onChange={onInputChange}>
                    {!groups.find((group) => group.title === 'Aucun groupe') && (
                        <option value="">{t('coach.trainingSessions.noGroup')}</option>
                    )}
                    {groups.map((group) => (
                        <option key={group.id} value={group.id}>
                            {group.title}
                        </option>
                    ))}
                </Form.Select>
            </Form.Group>
        </>
    )
}

export default TrainingSessionBasicFields
